/* eslint-disable max-len */
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { getUserIpAddress } from 'store/modules/user';
import CreateLeadModal from '../../../../website/components/stateful/UnitsTable/themes/StorageMart/CreateLeadModal';

const mapStateToProps = state => ({
  formValues: getFormValues('SMLeadForm')(state),
  ipAddress: getUserIpAddress(state),
});

export default connect(
  mapStateToProps,
  null,
)(CreateLeadModal);
